import React from 'react';

interface ItemIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export const ItemIcon: React.FC<ItemIconProps> = ({ className = '', size, ...props }) => {
  const sizeProps = size ? { width: size, height: size } : {};

  return (
    <svg
      {...props}
      {...sizeProps}
      className={className}
      viewBox="0 0 512 512"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Top face */}
      <path
        fill="#d2ae73"
        d="M 256.0451,9.6226717 42.563329,132.77228 256.0451,255.92189 469.16768,132.77228 v -0.20845 z"
      />
      {/* Stripe highlights on top face */}
      <path
        fill="#988543"
        d="M 349.13129,62.957536 135.64693,186.10792 172.80122,207.54151 385.92429,84.391126 v -0.20898 z"
      />
      <path
        fill="#c9c379"
        d="M 317.21541,44.206576 103.73105,167.35697 140.88534,188.79056 354.00841,65.640169 v -0.208984 z"
      />
      <path
        fill="#c9c379"
        d="M 361.01459,69.591518 147.53023,192.74191 184.68452,214.1755 397.80759,91.025108 v -0.20898 z"
      />
      {/* Right face */}
      <path
        fill="#906f3d"
        d="m 469.34653,379.0715 0.0901,-246.45544 -213.39157,123.30583 0.0895,246.14438 0.18052,0.10427 z"
      />
      {/* Light patch on right face */}
      <path
        fill="#e4dec0"
        d="m 447.64542,262.97377 0.0322,-88.15179 -76.32556,44.10383 0.0321,88.04054 0.0645,0.0373 z"
      />
      {/* Left face */}
      <path
        fill="#b89050"
        d="M 42.743653,379.07157 256.13524,502.37733 256.0451,255.92189 42.833076,132.92721 l -0.18057,0.10426 z"
      />
      {/* Blue label area */}
      <path
        fill="#43799e"
        d="m 437.19402,258.47528 0.0227,-62.15611 -53.8174,31.09775 0.0226,62.07767 0.0455,0.0263 z"
      />
      {/* Label lines */}
      <path
        fill="#41371c"
        d="M 340.98438 336.80273 L 287.16797 367.90039 L 287.18945 377.97656 L 287.23633 378.00391 L 340.96289 346.95898 L 340.98438 336.80273 z M 369.98047 348.86133 L 314.16406 379.95898 L 286.25586 395.50781 L 286.27734 405.58398 L 286.32227 405.61133 L 314.23242 390.0625 L 369.95898 359.01758 L 369.98047 348.86133 z M 362.02148 379.28711 L 339.99023 392.01758 L 308.20312 410.38477 L 286.17188 423.11523 L 286.19531 433.19141 L 286.24023 433.21875 L 308.27148 420.48828 L 339.9668 402.17383 L 361.99805 389.44336 L 362.02148 379.28711 z"
      />
      {/* Red diamond tag */}
      <path
        fill="#9d2c2c"
        d="m 121.1875,104.04883 a 4.0004,4.0004 0 0 0 -3.99609,0.008 l -33.113285,19.18945 a 4.0004,4.0004 0 0 0 0.01367,6.92969 l 33.187503,19.05859 a 4.0004,4.0004 0 0 0 4,-0.01 l 33.05664,-19.18945 a 4.0004,4.0004 0 0 0 1.99218,-3.54688 l -0.002,-0.0312 a 4.0004,4.0004 0 0 0 -2.00586,-3.38086 z m -1.98242,8.08594 25.15234,14.44336 -25.0957,14.56835 -25.171876,-14.45507 z"
      />
      {/* Top-left edge strips */}
      <path
        fill="#a39c4e"
        d="m 103.70842,231.82208 -0.0908,-64.45809 37.1392,21.45976 -0.0898,64.14517 -0.18098,0.10449 z m 40.15122,22.77442 -0.0908,-64.45809 37.13919,21.45975 -0.0898,64.14517 -0.18098,0.10449 z"
      />
    </svg>
  );
};
